import { render, staticRenderFns } from "./ChangePrograma.vue?vue&type=template&id=e2e63fd2"
import script from "./ChangePrograma.vue?vue&type=script&lang=js"
export * from "./ChangePrograma.vue?vue&type=script&lang=js"
import style0 from "./ChangePrograma.vue?vue&type=style&index=0&id=e2e63fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports